import taxonomy from './artistTaxonomy.json';

export const normalizeArtSearch = value => String(value || '').normalize('NFKD')
  .replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/watercolor/g, 'watercolour')
  .replace(/modeling/g, 'modelling').replace(/mehndi/g, 'mehendi').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();

const entries = [];
const add = path => {
  const label = path[path.length - 1];
  const aliases = path.flatMap(part => taxonomy.aliases?.[part] || []);
  entries.push({ label, path, key: path.join(' > '), search: normalizeArtSearch([...path, ...aliases].join(' ')) });
};
Object.entries(taxonomy.categories).forEach(([group, forms]) => {
  add([group]);
  Object.entries(forms).forEach(([form, specialities]) => {
    add([group, form]);
    specialities.forEach(item => {
      add([group, form, item]);
      (taxonomy.details?.[item] || []).forEach(detail => add([group, form, item, detail]));
    });
  });
});
taxonomy.visualStyles.forEach(style => add(['Visual Arts', style]));
export const taxonomyEntries = entries;

export function searchArtTaxonomy(query) {
  const clean = normalizeArtSearch(query);
  if (!clean) return [];
  const tokens = query.trim().split(/\s+/).map(normalizeArtSearch).filter(Boolean);
  const score = entry => entry.label.toLowerCase() === query.trim().toLowerCase() ? 0
    : normalizeArtSearch(entry.label) === clean ? 1
      : normalizeArtSearch(entry.label).startsWith(clean) ? 2
        : normalizeArtSearch(entry.label).includes(clean) ? 3 : 4;
  return entries.filter(entry => tokens.every(token => entry.search.includes(token)))
    .sort((a, b) => score(a) - score(b) || a.path.length - b.path.length || a.key.localeCompare(b.key));
}

// A parent filter includes its descendants and legacy names, without matching siblings.
export function artFilterTerms(label) {
  const normalized = normalizeArtSearch(label);
  const terms = new Set([normalized]);
  entries.forEach(entry => {
    if (entry.path.some(part => normalizeArtSearch(part) === normalized)) {
      terms.add(normalizeArtSearch(entry.label));
      (taxonomy.aliases?.[entry.label] || []).forEach(alias => terms.add(normalizeArtSearch(alias)));
    }
  });
  return terms;
}
